import { Skeleton, Table } from "antd";
import React from "react";

const TableWithLoadingWrapper = (props) => {
	let {
		// required props
        columns,
		dataSource,
		// props for handling loading
		rowSelection,
        loading,
		numLoadingEntries,
		dataFormat,
		loadingEntriesTop,
		// all of the rest props Table expects or needs
		...restProps
    } = props;

	if (loading) {
        numLoadingEntries = numLoadingEntries || 3;
		const loadingData = [];
		for (let i = 0; i < numLoadingEntries; i++) {
			loadingData.push({
				...dataFormat,
				key: `loading-${i}`,
				id: `loading-${i}`,
				isLoaderEntry: true,
			});
		}

		if (loadingEntriesTop === undefined || loadingEntriesTop) {
			dataSource = [...loadingData, ...dataSource];
		} else {
			dataSource = [...dataSource, ...loadingData];
		}
	}

	const newColumns = columns.map((col) => {
		return {
			...col,
			render: (text, record) => {
				if (record.isLoaderEntry) {
					return <Skeleton paragraph={{ rows: 0, width: 100 }} active />;
				} else {
					return col.render ? col.render(text, record) : text;
				}
			},
		};
	});

	let tableRowSelection = null;

	if (rowSelection) {
		tableRowSelection = {
			type: "checkbox",
			getCheckboxProps: (record) => {
				return {
					disabled: record.isLoaderEntry,
				}
			},
			...rowSelection,
		}
	}

	return (
		<Table
			columns={newColumns}
			dataSource={dataSource}
			expandable={props.expandableConfig}
			style={{ width: "100%" }}
			rowSelection={tableRowSelection}
			pagination={props.pagination ? props.pagination : { defaultPageSize: 50, showSizeChanger: true }}
			scroll={{
				x: 600,
			}}
			{...restProps}
			rowKey={props.rowKey || "id"}
		/>
	);
};

export default TableWithLoadingWrapper;
